import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import {
  storageLocationIdFormat,
  transferSessionIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

const ReceivingItemSchema_ = z.object({
  productId: productIdFormat.schema,
  quantity: z.number().int().positive(),
  lotNumber: z.string().optional(),
  expirationDate: z.date().optional(),
  /**
   * Receive mode only: a receiving-type bin to receive into instead of the
   * default RECEIVING bin. Ignored on damaged items.
   */
  storageLocationId: storageLocationIdFormat.schema.optional(),
});
export const ReceivingItemSchema: z.ZodType<ReceivingItem> =
  ReceivingItemSchema_;
export interface ReceivingItem extends z.infer<typeof ReceivingItemSchema_> {}

export const completeShipmentReceiving = {
  name: "completeShipmentReceiving" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    inboundShipmentId: z.string(),
    received: z.array(ReceivingItemSchema),
    damaged: z.array(ReceivingItemSchema),
    mode: z.enum(["receive", "place"]),
  }),
  output: z.object({
    transferSessionId: transferSessionIdFormat.schema,
    status: z.enum(["sourcing", "distributing", "completed"]),
  }),
};

export type CompleteShipmentReceivingInput = z.infer<
  typeof completeShipmentReceiving.input
>;
